var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6827 6.61248L3.38092 15.1719C2.86199 15.7069 2.01949 15.7031 1.50517 15.1633L1.04522 14.6806C0.537296 14.1476 0.540968 13.2921 1.05345 12.7637L12.3996 1.06541C12.9153 0.533698 13.7514 0.533699 14.2671 1.06541L25.6132 12.7637C26.1257 13.2921 26.1294 14.1476 25.6214 14.6806L25.1615 15.1633C24.6472 15.7031 23.8047 15.7069 23.2857 15.1719L14.984 6.61248L14.984 25.9718C14.984 26.7237 14.3928 27.3333 13.6635 27.3333H13.0032C12.2739 27.3333 11.6827 26.7237 11.6827 25.9718L11.6827 6.61248Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUp);
export default __webpack_public_path__ + "static/media/icon-arrow_up.3ea1d851b56c6a3a4c998c97b8bdac96.svg";
export { ForwardRef as ReactComponent };